import styled from 'styled-components'
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
} from 'react-icons/md'
import startCase from 'lodash.startcase'

import PlatformIcon, { PlatformIconProps } from 'Components/Common/PlatformIcon'
import getReviewKeyFromURL from 'utils/getReviewKeyFromURL'
import {
  handleStatusStateBg,
  handleStatusStateColor,
  TimeStyled,
} from 'Components/UpcomingPostCard'
import { ClockIcon } from 'Icons'

interface StatusLabelProps {
  status: string
  platform: PlatformIconProps['platform']
  time: string
  isMobile?: boolean
  isReadOnly: boolean
  className?: string

  postId: string
  isExpanded?: boolean
  updatePostState: (
    reviewKey: string,
    postId: string,
    finalState: string
  ) => void
  isDisplayTime: boolean
  children?: unknown
}

interface StatusLabelContainerProps {
  className?: string
  status: string
  isMobile?: boolean
  isReadOnly: boolean
}

export const StatusLabel = (props: StatusLabelProps) => {
  const {
    status,
    platform,
    time,
    isMobile,
    isReadOnly,
    className,
    postId,
    isExpanded,
    updatePostState,
    isDisplayTime,
  } = props
  const reviewKey = getReviewKeyFromURL(window.location.href)

  const handleUndo = (event: React.MouseEvent) => {
    updatePostState(reviewKey, postId, 'pending')
    event.preventDefault()
    event.stopPropagation()
  }

  return (
    <StatusLabelContainer
      className={className}
      status={status}
      isMobile={isMobile}
      isReadOnly={isReadOnly}
    >
      <div>
        <PlatformIconWrap>
          <PlatformIcon platform={platform} />
        </PlatformIconWrap>
        <div>
          <span>{isReadOnly ? time : startCase(status)}</span>
        </div>
      </div>
      <StatusLabelCaret>
        <div className="timeWrap">
          {isMobile && isDisplayTime && (
            <TimeStyled $isMobile={isMobile}>
              <div>
                <ClockIcon />
                {time}
              </div>
            </TimeStyled>
          )}
        </div>
        {status !== 'pending' && isMobile && (
          <Undo onClick={handleUndo}>Undo</Undo>
        )}
        {isMobile &&
          (isExpanded ? (
            <MdOutlineKeyboardArrowUp />
          ) : (
            <MdOutlineKeyboardArrowDown />
          ))}
      </StatusLabelCaret>
    </StatusLabelContainer>
  )
}

const StatusLabelCaret = styled.div`
  position: absolute;
  right: 12px;
  height: 36px;
  gap: 10px;
  .timeWrap {
    display: flex;
    margin: 0 !important;
    height: 36px;
    justify-content: center;
    align-items: center;
  }
  > div {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  > svg {
    width: 32px;
    height: auto;
  }
`

const Undo = styled.div`
  font-style: italic;
  font-size: 12px;
  color: white;
  cursor: pointer;
`

const StatusLabelContainer = styled.div<StatusLabelContainerProps>`
  display: flex;
  justify-content: space-between;
  height: 36px;
  border-radius: 5px 0 5px 0;
  background: ${({ status, isReadOnly }) =>
    handleStatusStateBg(status, isReadOnly)};
  color: ${({ status }) => handleStatusStateColor(status)};
  position: absolute;
  z-index: 2;
  left: -1.5px;
  top: -1.5px;
  padding: 7px 10px;
  font-weight: 700;
  font-size: 12px;
  min-width: ${(props) => (props.status === 'pending' ? '180px' : '220px')};
  align-items: center;

  > div {
    display: flex;
    align-items: center;
  }

  .action {
    font-style: italic;
    font-weight: normal;
    margin-left: 14px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  span {
    ${({ isReadOnly }) => isReadOnly && 'color: #ffffff'}
  }

  ${({ isReadOnly, isMobile }) =>
    isReadOnly && isMobile && 'min-width: calc(100% - 55px)'}
`

const PlatformIconWrap = styled.div`
  svg {
    width: 20px;
  }
  margin-right: 8px;
`
